import React, { useMemo } from 'react';

import { useMediaQuery } from 'react-responsive';
import Loading from 'components/layout/loading';
import { useNewRefuel } from '../../hooks/useNewRefuel';

import BaseItem from './components/BaseItem';
import HeaderList from './components/HeaderList';

import { Container, ContainerWrapper } from './styles';
import BaseItemMobile from './components/BaseItemMobile';

const SelectBases: React.FC = () => {
  const { bases, selectedBases, isLoading } = useNewRefuel();

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const orderedBases = useMemo(() => {
    return bases.sort((x, y) => {
      const a = x.nickname.toUpperCase();
      const b = y.nickname.toUpperCase();

      if (a === b) {
        return 0;
      }

      if (a > b) {
        return 1;
      }

      return -1;
    });
  }, [bases]);

  const basesFormatedd = useMemo(() => {
    return orderedBases.map((base) => {
      return {
        isSelected: selectedBases.some(
          (selectBase) => base.name === selectBase.name
        ),
        ...base,
      };
    });
  }, [selectedBases, orderedBases]);

  return (
    <ContainerWrapper>
      <HeaderList />
      <Container>
        {!isLoading && basesFormatedd.length === 0 && (
          <h2>Nenhuma base ativa encontrada.</h2>
        )}
        {isLoading && <Loading />}
        {!isLoading && basesFormatedd.length > 0 && (
          <>
            {basesFormatedd.map((base) => (
              <>
                {!isMobile && (
                  <BaseItem
                    nickName={base.nickname}
                    baseName={base.name}
                    isSelected={base.isSelected}
                    address={`${base.address}, ${base.number} - ${base.complement}`}
                    routeDays={base?.baseTerritory?.base?.suplayDays || '-'}
                    supplyWay={
                      base?.baseTerritory?.base?.suplayWay === 'Agendado'
                        ? 'Automático'
                        : base?.baseTerritory?.base?.suplayWay
                    }
                  />
                )}
                {isMobile && (
                  <BaseItemMobile
                    nickName={base.nickname}
                    baseName={base.name}
                    isSelected={base.isSelected}
                    address={`${base.address}, ${base.number} - ${base.complement}`}
                    routeDays={base?.baseTerritory?.base?.suplayDays || '-'}
                    supplyWay={
                      base?.baseTerritory?.base?.suplayWay === 'Agendado'
                        ? 'Automático'
                        : base?.baseTerritory?.base?.suplayWay
                    }
                  />
                )}
              </>
            ))}
          </>
        )}
      </Container>
    </ContainerWrapper>
  );
};

export default SelectBases;
